import { FlexBox } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { CompProps } from '@fable/types'

interface Props {
  id?: string
  className?: string
  stretch?: boolean
}

export const MLPSection = ({
  id = '',
  children,
  className = '',
  stretch = false,
}: CompProps<Props>) => {
  const { mediaQueries } = useTheme()

  return (
    <FlexBox
      id={id}
      className={cx(
        css`
          padding: 0 24px;
          ${mediaQueries.mobileL} {
            padding: 0 32px;
          }
        `,
        className
      )}
      justifyContent="center"
    >
      <div
        className={css`
          max-width: ${stretch ? 'none' : '1120px'};
          width: 100%;
        `}
      >
        {children}
      </div>
    </FlexBox>
  )
}
